import React, { useContext, useEffect, useState } from "react";
import { Table, Tag } from "antd";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../context/AppContext";
import { deleteCase } from "../../../APIs/caseApis";

// const data = [
//   {
//     key: "1",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "john@example.com" },
//     status: "Open",
//     contacts: "Jane Smith (Witness)",
//     deadlines: "Jane Smith (Witness)",
//     tasks: "Document filing, prepare evidence",
//   },
//   {
//     key: "2",
//     caseID: "C001",
//     clientInfo: { name: "Emily Davis", email: "emily@example.com" },
//     status: "Closed",
//     contacts: "Robert (Opposing Counsel)",
//     deadlines: "Robert (Opposing Counsel)",
//     tasks: "Case study on real estate regulations",
//   },
//   {
//     key: "3",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "michael@example.com" },
//     status: "Pending",
//     contacts: "Sarah (Witness)",
//     deadlines: "Sarah (Witness)",
//     tasks: "Notes on intellectual property law",
//   },
//   {
//     key: "4",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "john@example.com" },
//     status: "Open",
//     contacts: "Jane Smith (Witness)",
//     deadlines: "Jane Smith (Witness)",
//     tasks: "Document filing, prepare evidence",
//   },
//   {
//     key: "5",
//     caseID: "C001",
//     clientInfo: { name: "Emily Davis", email: "emily@example.com" },
//     status: "Closed",
//     contacts: "Robert (Opposing Counsel)",
//     deadlines: "Robert (Opposing Counsel)",
//     tasks: "Case study on real estate regulations",
//   },
//   {
//     key: "6",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "michael@example.com" },
//     status: "Pending",
//     contacts: "Sarah (Witness)",
//     deadlines: "Sarah (Witness)",
//     tasks: "Notes on intellectual property law",
//   },
//   {
//     key: "1",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "john@example.com" },
//     status: "Open",
//     contacts: "Jane Smith (Witness)",
//     deadlines: "Jane Smith (Witness)",
//     tasks: "Document filing, prepare evidence",
//   },
//   {
//     key: "2",
//     caseID: "C001",
//     clientInfo: { name: "Emily Davis", email: "emily@example.com" },
//     status: "Closed",
//     contacts: "Robert (Opposing Counsel)",
//     deadlines: "Robert (Opposing Counsel)",
//     tasks: "Case study on real estate regulations",
//   },
//   {
//     key: "3",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "michael@example.com" },
//     status: "Pending",
//     contacts: "Sarah (Witness)",
//     deadlines: "Sarah (Witness)",
//     tasks: "Notes on intellectual property law",
//   },
//   {
//     key: "4",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "john@example.com" },
//     status: "Open",
//     contacts: "Jane Smith (Witness)",
//     deadlines: "Jane Smith (Witness)",
//     tasks: "Document filing, prepare evidence",
//   },
//   {
//     key: "5",
//     caseID: "C001",
//     clientInfo: { name: "Emily Davis", email: "emily@example.com" },
//     status: "Closed",
//     contacts: "Robert (Opposing Counsel)",
//     deadlines: "Robert (Opposing Counsel)",
//     tasks: "Case study on real estate regulations",
//   },
//   {
//     key: "6",
//     caseID: "C001",
//     clientInfo: { name: "John Doe", email: "michael@example.com" },
//     status: "Pending",
//     contacts: "Sarah (Witness)",
//     deadlines: "Sarah (Witness)",
//     tasks: "Notes on intellectual property law",
//   },
// ];

const CaseTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cases, setCases] = useState([]);
  const [isdelModalOpen, setIsdelModalOpen] = useState(null);
  const { allCases, setAllCases, getAllCases } = useContext(AppContext);

  const { setSelectedCase } = useContext(AppContext);

  const handleDetailsClick = (caseItem) => {
    
    console.log("Selected case:", caseItem);
    navigate("/case/case-details",
    {
      state: { caseItem }
    }
    );
  };
  

  const columns = [
    {
      title: t("dashboard.caseManagement.caseID"),
      dataIndex: "caseID",
      key: "caseID",
      render: (text) => (
        <p className="text-darkGrey small font-poppins">{text}</p>
      ),
    },
    {
      title: t("dashboard.caseManagement.clientInfo"),
      dataIndex: "clientInfo",
      key: "clientInfo",
      render: (clientInfo) => (
        <div>
          <p className="text-darkGrey small font-poppins"> {clientInfo.name}</p>
          <p className="text-[#2183C6] small font-poppins">
            {/* {"( "} */}
            {clientInfo.email}
            {/* {" )"} */}
          </p>
        </div>
      ),
    },
    {
      title: t("dashboard.caseManagement.caseStatus"),
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={
            status === "Open" ? "green" : status === "Closed" ? "red" : "orange"
          }
          className="rounded-[54px] border-none px-3 py-1 text-white font-medium e-small"
        >
          {status}
        </Tag>
      ),
    },
    {
      title: t("dashboard.caseManagement.keyContacts"),
      dataIndex: "contacts",
      key: "contacts",
      render: (contacts) => (
        <p className="text-darkGrey small font-poppins">{contacts}</p>
      ),
    },
    {
      title: t("dashboard.caseManagement.deadlinesCourtDates"),
      dataIndex: "deadlines",
      key: "deadlines",
      render: (deadlines) => (
        <p className="text-darkGrey small font-poppins">{deadlines}</p>
      ),
    },
    {
      title: t("dashboard.caseManagement.taskAssignments"),
      dataIndex: "tasks",
      key: "tasks",
      render: (tasks) => (
        <p className="text-darkGrey small font-poppins">{tasks}</p>
      ),
    },

    {
      title: t("dashboard.caseManagement.actions"),
      key: "actions",
      render: (_, record) => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            // onClick={() => {
            //   navigate("/case/case-details");
            // }}
            onClick={() => handleDetailsClick(record)} // Pass selected case
          >
            {t("dashboard.caseManagement.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={() => {
              console.log(record._id);
              onDelClick(record._id);
            }}
          />
        </div>
      ),
    },
  ];

  const onDelClick = (caseId) => {
    setIsdelModalOpen(caseId);
  };

  useEffect(() => {
    const resultedData = allCases.data?.map((item, index) => {
      return {
        key: index + 1,
        caseID: item.caseId || "N/A",
        clientInfo: { name: item.client_name || "N/A" },
        status: item.case_status || "N/A",
        contacts: item.key_contacts || "N/A",
        deadlines: item.deadline_date
          ? item.deadline_date.split("T")[0]
          : "N/A",
        tasks: item.task_assignments || "N/A",
        _id: item._id,
      };
    });
    console.log(allCases.data);
    setCases(resultedData);
  }, [allCases]);

  useEffect(() => {
    getAllCases()
      .then((res) => {
        setAllCases(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Table
        columns={columns}
        dataSource={cases}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />

      <DelTableRowModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
      />
    </>
  );
};

export default CaseTable;
